import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const uploadImage = async (companyId, name, { file }) => {
  const formData = new FormData();

  //    !!!!!!!!!!  CHECK FOR EXACT PROPERTY NAMES  !!!!!!!!!!

  formData.append('name', name);
  formData.append('file', file);
  formData.append('file_ext', 'png'); // check for exact format
  formData.append('last_updated_user_id', '1');
  formData.append('parent_type', 'company');

  const { data } = await axios.post(`/api/companies/${companyId}/files`, formData);

  return data;
};

export const useImageUpload = (companyId, name, onSuccess = () => {}) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    //@ts-ignore
    mutationFn: (data) => uploadImage(companyId, name, data),
    onSuccess: () => {
      enqueueSnackbar('Image succesfully uploaded', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      //@ts-ignore
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
